var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('router-link',{staticClass:"details_btn",staticStyle:{"text-decoration":"none","color":"rgb(75, 44, 114)","width":"auto"},attrs:{"to":{
      name: 'dealerDashboard',
      query: {
        dealerId: _vm.data.id,
        companyId: this.$route.query.companyId
          ? this.$route.query.companyId
          : _vm.data.companyId,
      },
    }}},[_vm._v("\n    "+_vm._s(_vm.$t("text.clickButtons.view"))+"\n    "),_c('i',{staticClass:"fa fa-eye primary-color"})]),_vm._v(" "),_c('router-link',{staticClass:"details_btn",staticStyle:{"text-decoration":"none","color":"rgb(75, 44, 114)","width":"auto"},attrs:{"to":{
      name: 'our_branches',
      query: { dealerId: _vm.data.id, companyId: _vm.$route.query.companyId },
    }}},[_vm._v("\n    "+_vm._s(_vm.$t("text.clickButtons.branches"))+" "+_vm._s(_vm.data.numberOfBranches)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }